/**
 * @file Links charges to a payment through `payment/:id/link` and confirms it in a snackbar.
 * A refusal the payment-link route is known to send opens the refusal dialog with that path's texts.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence, ExpectedErrors } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

const EXPECTED_ERRORS: ExpectedErrors = {
  be_ajv_not_validated: null,
  financial_operations_were_blocked: { titleKey: "refusal-title-link", bodyKey: "refusal-body-financial-processing-busy" },
  be_dynamic_error: { titleKey: "refusal-title-link", bodyKey: "refusal-body-link-payment-or-charge-unavailable" },
  be_unauthorized: { titleKey: "refusal-title-link", bodyKey: "refusal-body-link-charges-fully-paid" },
  cannot_link_payment_paid_directly_to_owner_charge: { titleKey: "refusal-title-link", bodyKey: "refusal-body-link-direct-charge" },
  cannot_mix_payment_routes: { titleKey: "refusal-title-link", bodyKey: "refusal-body-mixed-payment-routes" },
  cannot_pay_charge_with_different_type_of_payment: { titleKey: "refusal-title-link", bodyKey: "refusal-body-payment-type-mismatch" },
  cannot_pay_charge_with_type_of_currency_different_from_payment: { titleKey: "refusal-title-link", bodyKey: "refusal-body-currency-mismatch" },
  payment_is_fully_used: { titleKey: "refusal-title-link", bodyKey: "refusal-body-payment-fully-used" }
};

export default function* paymentLink(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PAYMENT_LINK_REQUEST
    });

    yield call(Http.put, `payment/${action.payload?.payment?.id}/link`, {
      chargeIds: action.payload?.chargeIds
    });

    yield put({
      type: Constants.GLOBAL_PAYMENT_LINK_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-payment-linked-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action, EXPECTED_ERRORS);

    yield put({
      type: Constants.GLOBAL_PAYMENT_LINK_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentLink() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_LINK_START, paymentLink);
}
